
import { errManager } from '@/core/config/Tools';
import GlobalService from '@/core/services/GlobalService';
import { FormInstance, FormRules } from 'element-plus';
import { defineComponent, ref, reactive } from 'vue'
// http://localhost:8080/api/institution/1/edit

export default defineComponent({
    props:{
        itemPayroll: {
            type: Object,
            required: true,
            default: {}
        }
    },
    setup(props) {
        const REPO = ref(process.env.VUE_APP_REPO);
        const titleDialog      = ref('Solicitud de Traslado de Club');
        const isModalVisible   = ref<boolean>(false);
        const loaderClubOrigen = ref<boolean>(false);
        const loadingRemote    = ref<boolean>(false);
        const loadingForm      = ref<boolean>(false);
        const itemInstitution  = ref<any>({});
        const listInstitution  = ref<any[]>([]);
        const ruleFormRef      = ref<FormInstance>();
        const rules            = reactive<FormRules>({});
        const form             = reactive<any>({
            idinstitution: null
        });

        //events
        const openModal = () => {
            isModalVisible.value = true;
        };

        const onClosed = () => {
            itemInstitution.value = {}
            form.value = {}
        };

        const getInstitution = async() => {
            loaderClubOrigen.value = true;
            await GlobalService.get('api/institution', `${props?.itemPayroll?.idclub}/edit`)
            .then((res)=>{
                loaderClubOrigen.value = false;
                itemInstitution.value = res.data;
            }).catch(({ response })=>{
                loaderClubOrigen.value = false;
                errManager(response);
            }).finally(()=>{
                loaderClubOrigen.value = false;
            })
        };

        const remoteMethod = async (query: string) => {
            if (query.trim()) {
                loadingRemote.value = true;
                await GlobalService.post('institution/search', {search: query.toLowerCase()})
                .then((res)=>{
                    listInstitution.value = res.data
                    loadingRemote.value = false
                }).catch(({response})=>{
                    loadingRemote.value = false
                    errManager(response)
                })
            } else {
                listInstitution.value = []
            }
        };

        const onOpened = async() => {
            getInstitution();
        }

        return {
            REPO,
            titleDialog,
            isModalVisible,
            loaderClubOrigen,
            loadingRemote,
            loadingForm,
            form,
            ruleFormRef,
            rules,
            itemInstitution,
            listInstitution,

            //events
            openModal,
            onClosed,
            onOpened,
            remoteMethod
        }
    },
})
